<div class="receipt-type-tabs">
  <h2 class="receipt-type-tabs-label text-b3-m-700 text-md-b1-s-700 text-lg-b1-m-700 color-black">способ получения</h2>

  @if (receiptTypes(); as receiptTypes) {
    <div #tabs class="receipt-type-tabs-buttons">
      @for (receiptType of receiptTypes; track receiptType.code) {
        <button
          class="receipt-type-tabs-buttons-variant btn-icon text-b4-m-500 text-md-b3-s-500"
          [class.active]="activeModeId() === receiptType.code"
          (click)="setActive(receiptType.code)"
          [attr.data-testid]="receiptType.code + 'Btn'"
        >
          <sd-icon class="icon-size-s icon-size-md-m" [type]="variantIcon[receiptType.code]"></sd-icon>
          {{ receiptType.description }}
        </button>
      }
    </div>
  } @else {
    <div class="receipt-type-tabs-buttons sd-group-skeleton-gradient-wave">
      <div class="sd-skeleton"></div>
      <div class="sd-skeleton"></div>
    </div>
  }
</div>
